import { fetchAPI } from "@/api/api"
import { stringParam } from "@/schemas/requestParams"
import { z } from "zod/v4"

const FINGERPRINT_PRO_ENTERPRISE_TRACKER_API_URL =
  "/exchange/member/playerService/fingerprintProEnterpriseTracker"

const SUCCESS_STATUS = "0000"

// fingerprintProEnterpriseTracker (SACRIC-1434 API contract): either errorMsg (TG alert only)
// or eventId (looked up and recorded asynchronously). No publicKey — the Enterprise record
// table does not store it.
const fingerprintProEnterpriseTrackerRequestSchema = z.strictObject({
  // cut at 500 characters
  errorMsg: stringParam(500).optional(),
  eventId: stringParam(100).optional()
})

// 0000 accepted, 9999 blank eventId; 1001 (no player) is rejected inside fetchAPI
const fingerprintProEnterpriseTrackerResponseSchema = z.object({
  status: z.string(),
  status_msg: z.string()
})

export interface FingerprintProEnterpriseTrackerPayload {
  eventId?: string
  errorMsg?: string
}

const fetch = {
  url: FINGERPRINT_PRO_ENTERPRISE_TRACKER_API_URL,
  // Resolves true when the backend accepted the report (0000). For an eventId that only means
  // it was queued: the backend records it asynchronously.
  handler: async (payload: FingerprintProEnterpriseTrackerPayload): Promise<boolean> => {
    const res = await fetchAPI({
      url: FINGERPRINT_PRO_ENTERPRISE_TRACKER_API_URL,
      data: payload,
      requestSchema: fingerprintProEnterpriseTrackerRequestSchema,
      schema: fingerprintProEnterpriseTrackerResponseSchema
    })

    return res.status === SUCCESS_STATUS
  }
}

export default fetch
